export default "__VITE_ASSET__3911423f__"